import { createSlice } from "@reduxjs/toolkit";

import {
  getAdminOpenItemsListAction,
  addAdminOpenItemsAction,
  getAdminOpenItemsSingleAction,
  getClientOpenItemsListAction,
  updateAdminOpenItemsAction,
  uploadClientOpenItemsAction,
  getAllOpenItemCommentsAction,
  addOpenItemCommentsAction,
  updateStatusAdminOpenItemsAction,
  sendOpenItemEmailAction,
} from "@/redux/openItems/actions";
import { initialState } from "@/redux/openItems/initialState";
import type { OpenItemsType } from "@/redux/openItems/openItemsTypes";
import { openItemsReducer } from "@/redux/openItems/reducer";

export const openItemsSlice = createSlice({
  name: "openItems",
  initialState,
  reducers: openItemsReducer,

  extraReducers: (builder) => {
    builder.addCase(updateAdminOpenItemsAction.pending, (state: any) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateAdminOpenItemsAction.fulfilled,
      (state: any, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        } else {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            // error: message
          };
        }
      }
    );

    builder.addCase(
      updateAdminOpenItemsAction.rejected,
      (state: any, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message,
      })
    );

    builder.addCase(updateStatusAdminOpenItemsAction.pending, (state: any) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateStatusAdminOpenItemsAction.fulfilled,
      (state, { payload }) => {
        const { success, status_code, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        } else {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            // error: message
          };
        }
      }
    );

    builder.addCase(
      updateStatusAdminOpenItemsAction.rejected,
      (state: any, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message,
      })
    );

    builder.addCase(addAdminOpenItemsAction.pending, (state: any) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      addAdminOpenItemsAction.fulfilled,
      (state: any, { payload }) => {
        const { message, status_code, data, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: 200,
            error: message,
          };
        } else {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: 200,
            error: message,
          };
        }
      }
    );

    builder.addCase(
      addAdminOpenItemsAction.rejected,
      (state: any, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message,
      })
    );

    builder.addCase(getAdminOpenItemsSingleAction.pending, (state: any) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getAdminOpenItemsSingleAction.fulfilled,
      (state: any, { payload }) => {
        const { success, status_code, message, data } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        } else {
          return {
            ...state,
            fetching: false,
            // success,
            statusCode: status_code,
            error: message,
            adminOpenItemSingle: data,
          };
        }
      }
    );

    builder.addCase(
      getAdminOpenItemsSingleAction.rejected,
      (state: any, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message,
      })
    );

    builder.addCase(
      getAdminOpenItemsListAction.pending,
      (state: OpenItemsType) => {
        state.fetching = true;
      }
    );

    builder.addCase(
      getAdminOpenItemsListAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        state.fetching = false;
        state.statusCode = payload.status_code;

        if (payload.success === 0) {
          state.success = 0;
          state.error = payload.message;
        } else {
          state.adminOpenItemList = payload.data?.creator_open_item;
          state.sharedOpenItemsList = payload.data?.manager_open_item;
          state.error = null;
        }
      }
    );

    builder.addCase(
      getAdminOpenItemsListAction.rejected,
      (state: OpenItemsType, { error }) => {
        state.fetching = false;
        state.success = 0;
        state.error = error?.message ?? null;
      }
    );

    builder.addCase(
      getClientOpenItemsListAction.pending,
      (state: OpenItemsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientOpenItemsListAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        const { status_code, data, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            success,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          clientOpenItemList: data,
        };
      }
    );

    builder.addCase(
      uploadClientOpenItemsAction.pending,
      (state: OpenItemsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      uploadClientOpenItemsAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        const { status_code, data, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      uploadClientOpenItemsAction.rejected,
      (state: OpenItemsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getAllOpenItemCommentsAction.pending,
      (state: OpenItemsType) => ({
        ...state,
        commentsFetching: true,
      })
    );

    builder.addCase(
      getAllOpenItemCommentsAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        const { status_code, data, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            commentsFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          commentsFetching: false,
          openItemsCommentsList: data,
        };
      }
    );

    builder.addCase(
      getAllOpenItemCommentsAction.rejected,
      (state: OpenItemsType, { error }) => ({
        ...state,
        commentsFetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      addOpenItemCommentsAction.pending,
      (state: OpenItemsType) => ({
        ...state,
        commentsFetching: true,
      })
    );

    builder.addCase(
      addOpenItemCommentsAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        const { status_code, data, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            commentsFetching: false,
            commentsSuccess: success,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          commentsFetching: false,
          commentsSuccess: success,
        };
      }
    );

    builder.addCase(
      addOpenItemCommentsAction.rejected,
      (state: OpenItemsType, { error }) => ({
        ...state,
        commentsFetching: false,
        commentsSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      sendOpenItemEmailAction.pending,
      (state: OpenItemsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      sendOpenItemEmailAction.fulfilled,
      (state: OpenItemsType, { payload }) => {
        const { status_code, data, success, message } = payload;

        if (success === 0) {
          return {
            ...state,
            emailSuccess: success,
            statusCode: status_code,
            error: message,
            fetching: false,
          };
        }

        return {
          ...state,
          emailSuccess: success,
          fetching: false,
        };
      }
    );

    builder.addCase(
      sendOpenItemEmailAction.rejected,
      (state: OpenItemsType, { error }) => ({
        ...state,
        fetching: false,
        emailSuccess: 0,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetError: resetOpenItemsError,
  resetSuccess: resetOpenItemsSuccess,
  resetOpenItemsFetching,
  resetAdminOpenItemsList,
  resetClientOpenItemsList,
  resetSingleOpenItem,
  resetOpenItemsCommentList,
  resetEmailSuccess,
} = openItemsSlice.actions;
